import React from 'react'
import { Link } from 'react-router-dom';
import { capitalizeFirstLetter } from '../expFunction';

const NaveItems = (props) => {
    const hasChildren = (props?.item?.children || []).length > 0;
        
    return (
        <>
            {props.item.mega_menu ? (
                <li className="has-dropdown">
                    <Link to={"#"} className="main-menu-link text-capitalize" >{capitalizeFirstLetter(props.item.name)}
                        {hasChildren &&
                            <i className="fa fa-angle-down pl-1"></i>
                        }
                    </Link>
                    {hasChildren && 
                        <ul className="sub-menu">
                            {props.item.children.map((data, index) => (
                                <li key={index}>
                                    <Link to={data.href} onClick={data.onClick} >{capitalizeFirstLetter(data.name)}</Link>
                                </li>
                            ))}
                        </ul>
                    }
                </li>
            ) : (
                <li className="has-dropdown">
                    <Link to={props.item.href} className="main-menu-link">{props.item.name}
                    </Link>
                </li>
            )}

        </>
    )
}

export default NaveItems
